import { connect } from 'react-redux'
const mapStateToProps = (state) => {
    return {
        reservations: state?.pages?.accountOrders?.reservations,
    }
}

const hocTicketsReserved = (InnerComponent) => connect(mapStateToProps, {})(InnerComponent)

export default hocTicketsReserved
